import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import {
  submitCreateAccount,
  submitCreateCertificateOfLiabilityInsurance,
  submitUpdateAccount
} from '~/api/data/accounts/mutations';
import { loadAccount, loadAccounts, loadCertificate } from '~/api/data/accounts/queries';
import {
  AccountCertificateCreatePage,
  AccountCertificatePage,
  AccountCertificatesPage,
  AccountCreatePage,
  AccountEditPage,
  AccountOverviewPage,
  AccountPage,
  AccountPoliciesPage,
  AccountServiceRequestsPage,
  AccountsPage
} from '~/pages/accounts/accounts';

export const accountRoutes: RouteObject[] = [
  {
    path: 'accounts',
    loader: merge({
      accounts: loadAccounts
    }),
    element: <AccountsPage />,
    children: [
      {
        path: 'new',
        action: byMethod({
          POST: submitCreateAccount
        }),
        element: <AccountCreatePage />
      }
    ]
  },
  {
    id: 'accounts/:id',
    path: 'accounts/:id',
    loader: merge({
      account: loadAccount
    }),
    element: <AccountPage />,
    children: [
      {
        index: true,
        element: <Navigate to="overview" replace />
      },
      {
        path: 'edit',
        loader: merge({
          account: loadAccount
        }),
        action: byMethod({
          PUT: submitUpdateAccount
        }),
        element: <AccountEditPage />
      },
      {
        path: 'overview',
        element: <AccountOverviewPage />
      },
      {
        path: 'policies',
        element: <AccountPoliciesPage />
      },
      {
        path: 'certificates',
        element: <AccountCertificatesPage />,
        children: [
          {
            path: 'new',
            action: byMethod({
              POST: submitCreateCertificateOfLiabilityInsurance
            }),
            element: <AccountCertificateCreatePage />
          },
          {
            id: 'accounts/:id/certificates/:certificateId',
            path: ':certificateId',
            loader: merge({
              certificate: loadCertificate
            }),
            element: <AccountCertificatePage />
          }
        ]
      },
      {
        path: 'service',
        element: <AccountServiceRequestsPage />
      }
    ]
  }
];
